import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface Liste {
  "id": number,
  "datum": string,
  "name": string,
  "autor": string,
  "text": string;
}

@Injectable({
  providedIn: 'root'
})

export class GetDataService {

  liste = null;

  constructor(private http: HttpClient) {

    this.http.get<Liste[]>('assets/data.json').subscribe(
      resData => {
        this.liste = this.shuffle(resData);
        //console.log(this.liste);
      }
    )

  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}
